import { FormControl, Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Controller } from "react-hook-form";
import CustomInput from "../../../../../components/input/CustomInput";
import {
  AddEmissionContext,
  EmissionMode,
} from "../../../../../contexts/AddEmissionContext";
import { UploadFileZone } from "../../../../../components/input/UploadFileZone";
import { common, input, overview } from "../../../../../i18n";
import { useEffect, useState } from "react";
import { getDominantYearInRange } from "../../../../../utils/dateUtils";
import dayjs from "dayjs";

const AddEmissionSectionTwo: React.FC = () => {
  const { t } = useTranslation([common, overview, input], {
    nsMode: "fallback",
  });

  const { stepOneForm, stepTwoForm, emissionMode, subOrganizationList } =
    AddEmissionContext();

  const attachment = stepTwoForm.watch("attachment");

  const attachmentRef = stepTwoForm.watch("attachmentRef");

  const startDate = stepTwoForm.watch("startDate");

  const endDate = stepTwoForm.watch("endDate");

  const [year, setYear] = useState<number>(dayjs().year());

  useEffect(() => {
    if (!startDate || !endDate) return;
    setYear(getDominantYearInRange(startDate, endDate));
  }, [startDate, endDate]);

  return (
    <>
      <Grid item xs={12}>
        <FormControl fullWidth>
          <Controller
            name="remark"
            defaultValue=""
            control={stepTwoForm.control}
            rules={{
              required: false,
              maxLength: 255,
            }}
            render={({ field: { onChange, value } }) => (
              <CustomInput
                label={t("Remark")}
                info={t("Remark")}
                placeholder={t("Remark")}
                value={value}
                handleOnChange={onChange}
              />
            )}
          />
        </FormControl>
      </Grid>
      {emissionMode === EmissionMode.AddEmission && (
        <>
          <Controller
            name="attachment"
            defaultValue=""
            control={stepTwoForm.control}
            render={({ field: { onChange, value } }) => (
              <input value={value} onChange={onChange} type="hidden" />
            )}
          />
          <Controller
            name="attachmentRef"
            defaultValue=""
            control={stepTwoForm.control}
            render={({ field: { onChange, value } }) => (
              <input value={value} onChange={onChange} type="hidden" />
            )}
          />
          <Grid item xs={12}>
            <UploadFileZone
              attachment={attachment}
              setAttachmentValue={(value) =>
                stepTwoForm.setValue("attachment", value)
              }
              headline={`${t("Evidence-File")}`}
              description={t("Attachment-Description")}
              attachmentRef={attachmentRef}
              setAttachmentRefValue={(value) =>
                stepTwoForm.setValue("attachmentRef", value)
              }
              subOrganization={subOrganizationList.find(
                (s) => s.id === stepOneForm.getValues("subOrganizations"),
              )}
              year={year}
            />
          </Grid>
        </>
      )}
    </>
  );
};

export default AddEmissionSectionTwo;
